var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabAgentIconBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.17,
    height: 62.021,
    viewBox: "0 0 64.17 62.021",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2766",
    "data-name": "Group 2766",
    transform: "translate(-3503.096 -3350.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2765",
    "data-name": "Group 2765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1444",
    "data-name": "Group 1444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1440",
    "data-name": "Group 1440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M3538.461,3383.12v-18.945h-11.427v20.148",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_741",
    "data-name": "Rectangle 741",
    width: 6.56,
    height: 1.804,
    transform: "translate(3529.59 3366.58)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_742",
    "data-name": "Rectangle 742",
    width: 6.56,
    height: 1.804,
    transform: "translate(3529.59 3370.49)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_743",
    "data-name": "Rectangle 743",
    width: 6.56,
    height: 1.804,
    transform: "translate(3529.59 3374.399)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_744",
    "data-name": "Rectangle 744",
    width: 6.56,
    height: 1.804,
    transform: "translate(3529.59 3378.308)",
    fill: ""
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1438",
    "data-name": "Group 1438"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M3513.727,3393.795l-9.576-12.051,8.964-7.088,9.032,11.621",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_745",
    "data-name": "Rectangle 745",
    width: 6.275,
    height: 1.804,
    transform: "matrix(-0.784, 0.62, -0.62, -0.784, 3513.69, 3379.569)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_746",
    "data-name": "Rectangle 746",
    width: 6.275,
    height: 1.804,
    transform: "matrix(-0.784, 0.62, -0.62, -0.784, 3516.115, 3382.635)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_747",
    "data-name": "Rectangle 747",
    width: 6.275,
    height: 1.804,
    transform: "matrix(-0.784, 0.62, -0.62, -0.784, 3518.539, 3385.701)",
    fill: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1439",
    "data-name": "Group 1439"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M3556.636,3393.795l9.576-12.051-8.964-7.088-9.032,11.621",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_748",
    "data-name": "Rectangle 748",
    width: 6.275,
    height: 1.804,
    transform: "matrix(0.784, 0.62, -0.62, 0.784, 3557.793, 3378.153)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_749",
    "data-name": "Rectangle 749",
    width: 6.275,
    height: 1.804,
    transform: "matrix(0.784, 0.62, -0.62, 0.784, 3555.368, 3381.22)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_750",
    "data-name": "Rectangle 750",
    width: 6.275,
    height: 1.804,
    transform: "matrix(0.784, 0.62, -0.62, 0.784, 3552.943, 3384.286)",
    fill: ""
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M3544.48,3384.473v-33.114h-11.427v12.967",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_751",
    "data-name": "Rectangle 751",
    width: 5.429,
    height: 1.804,
    transform: "translate(3536.052 3353.764)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_752",
    "data-name": "Rectangle 752",
    width: 5.429,
    height: 1.804,
    transform: "translate(3536.052 3357.673)",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M3518.621,3388.774l2.925,1.713-1.5,7.217,7.819,3.909-1.2,6.315-9.022.6-4.51,3.308-5.413-.9a27.97,27.97,0,0,1,55.22-6.3l-4.1,4.795-3.909,1.5-8.119-1.5-.3-7.217-4.661-5.563.15-4.962,4.812-3.007,6.757.751",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M3527.381,3393.085l3.759,6.778,5.742-1.816v-7.86l-5.413.6-1.8-2.559Z",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1443",
    "data-name": "Group 1443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1441",
    "data-name": "Group 1441"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M3520.984,3366.823h-7.267v-7.267",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1121",
    "data-name": "Line 1121",
    y1: 9.699,
    x2: 9.233,
    transform: "translate(3513.717 3357.124)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1442",
    "data-name": "Group 1442"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M3549.38,3366.823h7.267v-7.267",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1122",
    "data-name": "Line 1122",
    x1: 9.233,
    y1: 9.699,
    transform: "translate(3547.414 3357.124)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabAgentIconBig);
export default __webpack_public_path__ + "static/media/tab-agent-icon-big.b4a675108658022952e0f80147903946.svg";
export { ForwardRef as ReactComponent };